Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBrand = void 0;
var _styles = require("../../../../../styles");
var _reactNative = require("react-native-web");
var useBrand = exports.useBrand = function useBrand() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    boxShadows = _STYLES$useStyles.boxShadows;
  var brand = {
    label: Object.assign({
      textDecorationLine: 'none',
      backgroundColor: colors.brand,
      color: colors.brandContrast
    }, _reactNative.Platform.select({
      web: {
        border: 0,
        cursor: 'pointer'
      }
    }), boxShadows.button.web, boxShadows.button.android),
    pointerOver: Object.assign({}, boxShadows.button_pointerOver.web)
  };
  return {
    brand: brand
  };
};